// BlogApprovalQueue.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import "./BlogApprovalQueue.css";

const BlogApprovalQueue = () => {
  const [pendingPosts, setPendingPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPendingPosts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/blog/posts?status=pending_approval`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setPendingPosts(response.data);
        setError(null);
      } catch (err) {
        setError("Failed to fetch pending posts");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingPosts();
  }, [token]);

  const handleApprove = async (postId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/blog/posts/${postId}/approve`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Remove the approved post from the list
      setPendingPosts(pendingPosts.filter((post) => post._id !== postId));
    } catch (err) {
      setError(
        `Failed to approve post: ${err.response?.data?.message || err.message}`
      );
      console.error(err);
    }
  };

  if (loading) return <div className="loading">Loading approval queue...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="blog-approval-queue">
      <h2>Posts Pending Approval ({pendingPosts.length})</h2>

      {pendingPosts.length === 0 ? (
        <div className="no-pending-posts">No posts pending approval</div>
      ) : (
        <div className="pending-posts-list">
          {pendingPosts.map((post) => (
            <div key={post._id} className="pending-post-card">
              <div className="post-header">
                <h3>{post.title}</h3>
                <span className="post-date">
                  Submitted: {new Date(post.updatedAt).toLocaleDateString()}
                </span>
              </div>

              <div className="post-meta">
                <span className="post-author">
                  By: {post.author.firstName} {post.author.lastName}
                </span>
                <span className="post-category">Category: {post.category}</span>
              </div>

              <div className="post-excerpt">{post.excerpt}</div>

              <div className="post-actions">
                <button
                  className="review-btn"
                  onClick={() => navigate(`/staff/blog/review/${post._id}`)}
                >
                  Review Post
                </button>
                <button
                  className="quick-approve-btn"
                  onClick={() => handleApprove(post._id)}
                >
                  Quick Approve
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogApprovalQueue;
